import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { initKeycloak, isAuthenticated, doLogin } from "./api/keycloak";
import CabinetPage from "./pages/CabinetPage";
import "./App.css";
import ToastContainer from "./components/Toast/ToastContainer";

function PrivateRoute({ children, keycloakReady }) {
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Чекаємо поки Keycloak ініціалізується
    if (!keycloakReady) {
      return;
    }

    // Перевіряємо авторизацію через Keycloak
    const authenticated = isAuthenticated();
    console.log("PrivateRoute: checking auth, result:", authenticated);
    
    if (!authenticated) {
      // Если не авторизован, сразу перенаправляем на Keycloak
      console.log("User not authenticated, redirecting to Keycloak login...");
      doLogin();
      return;
    }
    
    setChecking(false);
  }, [keycloakReady]);

  if (!keycloakReady || checking) {
    return <div>Перевірка авторизації...</div>;
  }

  return children;
}

function App() {
  const [keycloakReady, setKeycloakReady] = useState(false);

  useEffect(() => {
    // Инициализируем Keycloak только один раз при загрузке приложения
    if (keycloakReady) {
      return;
    }

    initKeycloak(() => {
      setKeycloakReady(true);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Пустой массив зависимостей - инициализируем только один раз

  if (!keycloakReady) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <div>Завантаження...</div>
        <div style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
          Підключення до системи автентифікації
        </div>
      </div>
    );
  }

  return (
    <>
    <Router basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<Navigate to="/cabinet/general" replace />} />
        <Route
          path="/cabinet"
          element={<Navigate to="/cabinet/general" replace />}
        />
        <Route
          path="/cabinet/:tab/:conversationId?"
          element={
            <PrivateRoute keycloakReady={keycloakReady}>
              <CabinetPage />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
     <ToastContainer />
    </>
  );
}

export default App;


